import { NetworkError } from '../../state-machine/actions/genericActions';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { SigningErrors, SignLoanAgreementInput } from '../../gql/graphql';
import loansService from '../../services/loan.service';

export interface SignLoanAgreementResult {
  signLoanAgreementErrors?: SigningErrors[];
  loanAgreementSigned?: boolean;
}

const signLoanAgreement = async (input: SignLoanAgreementInput) => {
  try {
    let response: any = await loansService.signLoanAgreement(input);

    if (response?.data?.signLoanAgreement?.signingErrors?.length) {
      return {
        signLoanAgreementErrors: response?.data?.signLoanAgreement.signingErrors,
      };
    } else {
      return {
        loanAgreementSigned: true,
      };
    }
  } catch (err: any) {
    let error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = { displayText: 'Unable to sign loan agreement' };
        // TODO: OK to leave in this console log of an error?
        console.error(err);
    }
    throw error;
  }
};

export default signLoanAgreement;
